// Vue 2 plugin to provide $confirm and $alert using a shared observable state
import Vue from 'vue'

// Reactive state for the global dialog
export const confirmState = Vue.observable({
  visible: false,
  mode: 'alert', // 'alert' | 'confirm'
  title: '',
  message: '',
  color: 'primary',
  confirmText: 'Aceptar',
  cancelText: 'Cancelar',
  persistent: true,
  // internal promise hooks
  _resolve: null,
})

function openDialog(opts = {}, mode = 'alert') {
  return new Promise((resolve) => {
    const o = typeof opts === 'string' ? { message: opts } : (opts || {})
    confirmState.title = o.title || (mode === 'confirm' ? 'Confirmar' : 'Aviso')
    confirmState.message = o.message || ''
    confirmState.color = o.color || 'primary'
    confirmState.confirmText = o.confirmText || (mode === 'confirm' ? 'Confirmar' : 'Aceptar')
    confirmState.cancelText = o.cancelText || 'Cancelar'
    confirmState.persistent = typeof o.persistent === 'boolean' ? o.persistent : true
    confirmState.mode = mode
    confirmState._resolve = resolve
    confirmState.visible = true
  })
}

const ConfirmPlugin = {
  install(VueInstance) {
    // Alert: resolves when user presses OK
    VueInstance.prototype.$alert = function alertDialog(opts) {
      return openDialog(opts, 'alert').then(() => true)
    }

    // Confirm: resolves to true/false
    VueInstance.prototype.$confirm = function confirmDialog(opts) {
      return openDialog(opts, 'confirm')
    }
  },
}

export default ConfirmPlugin
